import { createReducer } from "redux-act";

import * as action from "../actions/exportConfigAction";

const initialState = {
  maxRecords: null,
};

const exportConfigReducer = createReducer(
  {
    [action.setExportConfig]: (state, payload) => ({
      ...state,
      ...payload,
    }),
  },
  initialState
);

export default exportConfigReducer;
